import { Component, DestroyRef, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ConnectivityService } from './connectivity.service';
import { map } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-synchronization-online-icon',
  standalone: true,
  imports: [AsyncPipe],
  template: `
    <!-- TODO ZNT-1447: replace with zenith-icon -->
    @if(offline$ | async) {
      <div class="flex-center">
        <object
          type="image/svg+xml"
          data="/assets/icons/offline.svg"
          class="zn-text-color-error fade-in-out-loop"
        ></object>
      </div> 
    }
  `,
  styles: `
      @keyframes fadeIn {
          from {
              opacity: 20%;
          }
      }

      .fade-in-out-loop {
          animation: fadeIn 1s infinite alternate;
      }
  `
})
export class SynchronizationOnlineIconComponent {
  private readonly connectivityService = inject(ConnectivityService);
  private readonly destroyRef = inject(DestroyRef);

  readonly offline$ = this.connectivityService.online$.pipe(
    takeUntilDestroyed(this.destroyRef),
    map((online) => !online)
  );
}
